<div class="qe-numeric" [formGroup]="group">

  <div class="qe-numeric__fields">
    <div class="qe-numeric__field">
      <label class="qe-numeric__label" for="qe-numeric-value">
        {{ 'QUESTION_EDITOR.EXPECTED_VALUE' | translate }}
      </label>
      <input
        id="qe-numeric-value"
        class="form-control qe-numeric__input"
        type="number"
        step="any"
        formControlName="value"
        [placeholder]="'QUESTION_EDITOR.EXPECTED_VALUE_PLACEHOLDER' | translate" />
    </div>

    <span class="qe-numeric__pm">±</span>

    <div class="qe-numeric__field">
      <label class="qe-numeric__label" for="qe-numeric-tolerance">
        {{ 'QUESTION_EDITOR.TOLERANCE' | translate }}
      </label>
      <input
        id="qe-numeric-tolerance"
        class="form-control qe-numeric__input"
        type="number"
        step="any"
        min="0"
        formControlName="tolerance"
        placeholder="0" />
    </div>
  </div>

  @if (range(); as accepted) {
    <p class="qe-numeric__range">
      <i class="fa-solid fa-arrows-left-right-to-line"></i>
      @if (isExact()) {
        {{ 'QUESTION_EDITOR.RANGE_EXACT' | translate: { value: accepted.min } }}
      } @else {
        {{ 'QUESTION_EDITOR.RANGE_ACCEPTED' | translate: { min: accepted.min, max: accepted.max } }}
      }
    </p>
  }

  <p class="qe-numeric__rule">
    <i class="fa-regular fa-circle-question"></i>
    {{ 'QUESTION_EDITOR.RULE_NUMERIC' | translate }}
  </p>
</div>
